import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-commitments-tab-1-part',
	standalone: true,
	templateUrl: './admissions-commitments-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-commitments-tab-1.part.scss`],
})
export class AdmissionsCommitmentsTab1Part {
}
